<template>
  <div>
    <div class="d-flex align-center">
      <h3>Estados com mais vendas</h3>
      <v-spacer></v-spacer>
    </div>

    <v-divider class="ma-2"></v-divider>
    <v-data-table
      :items="statesSales"
      :loading="statesloading"
      :headers="statesHeaders"
      class="content-table"
      hide-default-footer
      loading-text="Buscando..."
      no-data-text="Sem registros"
    >
      <template v-slot:[`item.salesValue`]="{ item }">
        {{
          item.salesValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        }}
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "States",
  components: {Pagination},

  props: {
    filter: {
      resaleId: "",
      startDate: "",
      endDate: "",
    },
  },

  data() {
    return {
      apiService: new ApiService(),
      statesSales: [],
      page: 1,
      totalPages: 1,
      pageSize: 10,
      currentPage: 1,
      totalItems: 1,
      statesHeaders: [
        {
          text: "Estado",
          align: "center",
          value: "state",
        },
        {
          text: "Quantidade",
          align: "center",
          value: "salesQuantity",
          sortable: false,
        },
      ],
      statesloading: false,
    };
  },

  created() {
    this.getStateSales();
  },

  methods: {
    getStateSales() {
      this.statesloading = true;
      this.apiService
        .post("dashresale/states", { ...this.filter, page: this.page })
        .then((response) => {
          this.statesSales = response.content.data;
          this.totalPages = response.content.pager.totalPages;
          this.statesloading = false;
        })
        .catch(() => {
          this.statesloading = false;
        });
    },


    async backPage() {
      this.page -= 1;
      await this.getProductSales();
    },

    async nextPage() {
      this.page += 1;
      await this.getProductSales();
    },
  },
};
</script>

<style></style>
